import { Grid } from '@material-ui/core';
import QCXMainLayout from '../../../../components/main-layout/QCXMainLayout';
import GestaoAVistaEtapaCard from './components/GestaoAVistaEtapaCard';
import GestaoAVistaEtapaList from './components/GestaoAVistaEtapaList';
import GestaoAVistaEtapasSemaforo from './components/GestaoAVistaEtapasSemaforo';
import GestaoAVistaFollowUpList from './components/GestaoAVistaFollowUpList';
import useGestaoAVista from './hooks/gestaoAVista.hook';

export default function GestaoAVistaDashboardPage({ authInfo = {} }) {
  const {
    selectedEstagio,
    setSelectedEstagio,
    selectedEtapa,
    setSelectedEtapa,
    isLoadingProcessosCapa,
    isLoadingEtapasCapa,
    isLoadingProcessos,
    processosCapaConfig,
    etapasCapa,
    processos,
    processosCount,
    etapas,
    listConfig,
    onListConfigChange,
  } = useGestaoAVista();

  return (
    <QCXMainLayout pageTitle="Gestão à vista" breadcrumbs={[]} isLoading={false} authInfo={authInfo} forceDefaultTheme>
      <Grid container spacing={2} xs={12} style={{ marginBottom: 64 }}>
        {processosCapaConfig.map((gestaoEtapa) => (
          <Grid item xs={12} md={4} lg={3}>
            <GestaoAVistaEtapaCard
              name={gestaoEtapa.name}
              total={gestaoEtapa.total}
              totalAereo={gestaoEtapa.aereo}
              totalMaritimo={gestaoEtapa.maritimo}
              totalRodoviario={gestaoEtapa.rodoviario}
              backgroundColor={gestaoEtapa.backgroundColor}
              light={gestaoEtapa.light}
              loading={isLoadingProcessosCapa}
              selected={selectedEstagio === gestaoEtapa.estagio}
              onSelectedChange={() => setSelectedEstagio(gestaoEtapa.estagio)}
              noneSelected={selectedEstagio === undefined}
            />
          </Grid>
        ))}
      </Grid>

      <Grid container spacing={2} xs={12} style={{ marginTop: 32 }}>
        <Grid item xs={12}>
          <GestaoAVistaEtapasSemaforo
            loading={isLoadingEtapasCapa}
            etapasNoPrazo={etapasCapa.etapasNoPrazo}
            etapasARealizar={etapasCapa.etapasARealizar}
            etapasVencendo={etapasCapa.etapasVencendo}
            etapasVencidas={etapasCapa.etapasVencidas}
            selected={selectedEtapa}
            onSelectedChange={setSelectedEtapa}
          />
        </Grid>
      </Grid>

      <Grid container spacing={2} xs={12} style={{ marginTop: 32 }}>
        {selectedEstagio ? (
          <GestaoAVistaFollowUpList
            pageSize={listConfig?.pageSize ?? 0}
            onConfigChangeCallback={onListConfigChange}
            processosCount={processosCount}
            processos={processos}
            loading={isLoadingProcessos}
          />
        ) : null}
        {selectedEtapa ? (
          <GestaoAVistaEtapaList
            pageSize={listConfig?.pageSize ?? 0}
            onConfigChangeCallback={onListConfigChange}
            processosCount={processosCount}
            processos={processos}
            etapas={etapas}
            loading={isLoadingProcessos}
          />
        ) : null}
      </Grid>
    </QCXMainLayout>
  );
}
